export default "__VITE_ASSET__BTqWH8Fo__"